import React from 'react';
import {UsersList} from "../users";

const CaptainsList = (props) => <UsersList role={'Капитан'} {...props}/>

export {CaptainsList}